<template>
    <div style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">

        <el-form ref="form" :model="form2" label-width="180px">
            <el-form-item label="随行付通道" class="grid-content bg-purple-dark">
            </el-form-item>
            <el-form-item label="经营类目：">{{jy_lm_sxf}}</el-form-item>
            <el-form-item label="结算费率(%)：">{{rate_sxf}}</el-form-item>


        </el-form>


        <el-form ref="form" :model="form3" label-width="180px">
            <el-form-item label="进件状态" class="grid-content bg-purple-dark">
            </el-form-item>
            <el-form-item label="进件时间："></el-form-item>
            <el-form-item label="微信费率："></el-form-item>
            <el-form-item label="支付宝费率："></el-form-item>
            <el-form-item label="商户编号："></el-form-item>
            <el-form-item label="注册名称："></el-form-item>
            <el-form-item label="进件状态："></el-form-item>
            <el-form-item label="进件结果："></el-form-item>
        </el-form>

    </div>


</template>
<style>

    .bg-purple-dark {
        background: #e5e9f2;
    }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
    export default {
        name: "child4",
        props: ["agentid_f4"],
        components: { },
        data() {
            return {
                jy_lm_sxf:'',
                rate_sxf:'',
                loading: false,
                oneagent: {},
                form2: {},
                form3: {},
                editFormVisible: false
            };
        },
        mounted() {
            this.getTableData();
        },
        methods: {
            getTableData() {
                var formData4 = new FormData() // 声明一个FormData对象
                formData4.append("agentid",this.agentid_f4);
                agentService.getPerfectAgent(formData4).then(data => {
                    if(data!=null && data!=""){



                        this.jy_lm_sxf=data.jy_lm_sxf;
                        this.rate_sxf=data.rate_sxf;


                    }
                });
            }
        }
    };
</script>